var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppTableControl',{attrs:{"search-place-holder":_vm.$t('COMMON.Actions.Search'),"no-export":"","no-filter":""},on:{"query-debounced":_vm.searchName}})}
var staticRenderFns = []

export { render, staticRenderFns }